// extracted by mini-css-extract-plugin
module.exports = {"txButton":"styles_txButton__Gz8d6","iconBg":"styles_iconBg__mkeVf","chip":"styles_chip__LGHEN"};